import { useParams } from "react-router-dom";
import SpotifyAlbumList from "./SpotifyAlbumList";
import SpotifyArtistList from "./SpotifyArtistList";
import SpotifyList from "./SpotifyList";
import SpotifyLocation from "./SpotifyLocation";
import SpotifyLyric from "./SpotifyLyric";
import SpotifyPlayer from "./SpotifyPlayer";
import SpotifyRecommend from "./SpotifyRecommend";
import { useState, useEffect } from "react";
import { WeddingInfo } from "../WeddingInfo/WeddingInfo";
import useBackgroundMusic from "../Common/useBackgroundMusic";
import { FaVolumeHigh, FaVolumeXmark } from "react-icons/fa6";
import WeddingCalendar from "../Common/WeddingCalendar";

const SplashScreen = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-black">
      <img
        src={`${process.env.PUBLIC_URL}/spotify.png`}
        alt="Metflix Logo"
        className="w-40 h-auto"
      />
      <div className="text-3xl text-spotify font-bold mt-4">Marritify</div>
    </div>
  );
};

const SpotifyScreen = () => {
  const [isLoading, setIsLoading] = useState(true);
  const { id } = useParams();
  const info = WeddingInfo.getInfo(id);

  const bgmSongName =
    window.location.hostname == "xn--vj5bwo95cw9x.com"
      ? "everything.mp3"
      : "wedding-sample-music.mp3";
  const { isMuted, toggleMute } = useBackgroundMusic(
    `${process.env.PUBLIC_URL}/${bgmSongName}`
  );

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  if (isLoading) {
    return <SplashScreen />;
  }

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-black">
      <meta name="theme-color" content="#000000" />
      <meta name="mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-status-bar-style" content="#000000" />
      <div className="w-full max-w-md bg-black text-center mb-12">
        <div className="w-full max-w-md bg-white p-0 text-center mb-12 relative">
          {/* 🔊 뮤트 버튼 */}
          <button
            onClick={toggleMute}
            className="absolute top-4 right-4 z-50 bg-white bg-opacity-80 hover:bg-opacity-100 transition p-2 rounded-full"
          >
            {isMuted ? (
              <FaVolumeXmark className="text-black w-5 h-5" />
            ) : (
              <FaVolumeHigh className="text-black w-5 h-5" />
            )}
          </button>
        </div>

        <div className="relative w-10 h-10 flex space-x-2 ml-4 mt-4">
          <img
            src={`${process.env.PUBLIC_URL}/spotify.png`}
            alt="Music Icon"
            className=""
          />
          <div className="text-3xl text-white text-left font-bold">
            Marritify
          </div>
        </div>

        <SpotifyAlbumList
          albums={info.spotify.albums}
          title={info.spotify.albumTitle}
        />

        <SpotifyLyric
          lyricInfos={info.spotify.lyrics}
          title={info.spotify.lyricTitle}
        />

        <SpotifyPlayer player={info.spotify.player} />

        <SpotifyRecommend list={info.spotify.list} />

        <SpotifyArtistList artist={info.spotify.artist} />

        <SpotifyLocation
          location={info.common.addressInfo}
          weddingDate={info.common.weddingDateKR}
        />

        <WeddingCalendar
         weddingDateKR={info.common.weddingDateKR}
          weddingDate={info.common.weddingDate}
          backgroundColor={"bg-spotify"}
          textColor={"text-spotify"}
        />

        <SpotifyList accountInfos={info.common.accountInfos} />
      </div>
    </div>
  );
};

export default SpotifyScreen;
